'use client';
import { CountBadge } from '@/shared/ui/CountBadge';
import { cva } from 'class-variance-authority';
import { motion } from 'framer-motion';
import { ChangeEventHandler, FC } from 'react';
import { twMerge } from 'tailwind-merge';

export type TogglerValue = 'reviews' | 'questions';

interface Props {
  className?: string;
  value: TogglerValue;
  onChange: ChangeEventHandler<HTMLInputElement>;
  reviewsCount: number;
  questionsCount: number;
}

export const Toggler: FC<Props> = ({ className, value, onChange, reviewsCount, questionsCount }) => {
  return (
    <div className={twMerge(cvaRoot(), className)}>
      <label className={cvaLabel()}>
        <input
          className={cvaInput()}
          type={'radio'}
          name={'reviewsAndQaTab'}
          value={'reviews'}
          checked={value === 'reviews'}
          onChange={onChange}
        />
        <span className={cvaValue()}>Отзывы</span>
        {reviewsCount > 0 ? <CountBadge className={cvaCountBadge()}>{reviewsCount}</CountBadge> : null}
        {value === 'reviews' && (
          <motion.div
            className={cvaUnderline()}
            layoutId={'underline'}
            transition={{
              layout: {
                duration: 0.3,
                ease: 'easeOut',
              },
            }}
          />
        )}
      </label>
      <label className={cvaLabel()}>
        <input
          className={cvaInput()}
          type={'radio'}
          name={'reviewsAndQaTab'}
          value={'questions'}
          checked={value === 'questions'}
          onChange={onChange}
        />
        <span className={cvaValue()}>Вопросы</span>
        {questionsCount > 0 ? <CountBadge className={cvaCountBadge()}>{questionsCount}</CountBadge> : null}
        {value === 'questions' && (
          <motion.div
            className={cvaUnderline()}
            layoutId={'underline'}
            transition={{
              layout: {
                duration: 0.3,
                ease: 'easeOut',
              },
            }}
          />
        )}
      </label>
    </div>
  );
};

const cvaRoot = cva(['Toggler-cvaRoot', 'flex items-center gap-1.6', 'font-secondary text-h3']);

const cvaLabel = cva(['Toggler-cvaLabel', 'relative', 'pb-2.2 pr-1.6', 'cursor-pointer']);

const cvaInput = cva(['Toggler-cvaInput', 'appearance-none', ' [&:checked+span]:text-cBlack']);

const cvaValue = cva(['Toggler-cvaValue', ' text-cBlack48', ' transition-colors duration-300 ease-out']);

const cvaCountBadge = cva([
  'Toggler-cvaCountBadge',
  'absolute top-0 right-0',
  'w-2.2 h-2.2',
  'outline-cWhite',
  'text-bodyS font-base',
]);

const cvaUnderline = cva([
  'Toggler-cvaUnderline',
  'absolute bottom-0 left-0',
  'w-full h-0.6',
  'rounded-t-[1.2rem]',
  'bg-cMediumGreen',
]);
